var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadFillBlueBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Load_Fill",
    "data-name": "Load Fill",
    transform: "translate(-78 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 32,
    height: 32,
    transform: "translate(78 228)",
    fill: "#13bcd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Carrier_Fill",
    "data-name": "Carrier Fill",
    transform: "translate(80.667 234.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M0,233.655a.482.482,0,0,0,.483.506h.771a3.412,3.412,0,0,1,3.065-2.006,3.413,3.413,0,0,1,3.065,2.006H17.4v-4.1H0Z",
    transform: "translate(0 -219.112)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M32.743,277.32a2.271,2.271,0,1,0,2.271,2.271A2.271,2.271,0,0,0,32.743,277.32Z",
    transform: "translate(-28.425 -263.193)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M283.908,192.015l-2.163-.951H275v6.718h1.309a3.345,3.345,0,0,1,6.13,0h1.281a.482.482,0,0,0,.483-.506V192.5A.522.522,0,0,0,283.908,192.015Z",
    transform: "translate(-256.527 -182.732)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M279.521,121.891a1.543,1.543,0,0,0-1.393-.829H275v3.628h5.973Z",
    transform: "translate(-256.527 -117.431)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M17.395,9.875H0v-8.3A1.559,1.559,0,0,1,1.534,0H15.853a1.549,1.549,0,0,1,1.542,1.57v8.3ZM5.771,4.531a.443.443,0,0,0-.439.445.422.422,0,0,0,.133.3L7.8,7.611a.431.431,0,0,0,.615,0l4.2-4.2a.431.431,0,0,0,.126-.307.435.435,0,0,0-.126-.309A.422.422,0,0,0,12,2.8L8.1,6.688,6.078,4.658A.432.432,0,0,0,5.771,4.531Z",
    transform: "translate(0.001)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M308.576,277.32a2.271,2.271,0,1,0,2.271,2.271h0A2.271,2.271,0,0,0,308.576,277.32Z",
    transform: "translate(-285.729 -263.193)",
    fill: "#13bcd4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadFillBlueBig);
export default __webpack_public_path__ + "static/media/loadFillBlueBig.8cbe36cf799cf96771e65182e0c27397.svg";
export { ForwardRef as ReactComponent };